import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../atoms/BaseButton';
import useDownload from '../../hooks/useDownload';
import { CircularProgress } from '@mui/material';
import { DownloadIcon } from '../atoms/Icons';
var DownloadButton = function (_a) {
    var title = _a.title, path = _a.path, downloadFilename = _a.downloadFilename, _b = _a.params, params = _b === void 0 ? {} : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.withDownloadTimestamp, withDownloadTimestamp = _d === void 0 ? false : _d;
    var t = useTranslation().t;
    var download = useDownload({
        path: path,
        downloadFilename: downloadFilename,
        params: params,
        withDownloadTimestamp: withDownloadTimestamp,
    });
    return (React.createElement(Button, { onClick: download.handleDownload, disabled: download.downloading, "aria-label": "CSV Download", size: size },
        download.downloading ? (React.createElement(CircularProgress, { color: "inherit", size: 24 })) : (React.createElement(DownloadIcon, null)), title !== null && title !== void 0 ? title : t('buttons.downloadCsv')));
};
export default DownloadButton;
